const messages = {
    date: 'Data',
    time: 'Godzina',
    clear: 'Wyczyść',
    save: 'Zapisz',
    noData: 'Brak danych',
    components: {
        toolbar: {
            welcomeMessage: 'Witaj',
            environmentBadge: 'Środowisko {env}'
        },
        dataTable: {
            noDataMessage: 'Brak danych',
            loadingText: 'Ładowanie...',
            itemsPerPageText: 'Wierszy na stronie:',
            all: 'Wszystkie'
        }
    },
    buttons: {
        add: 'Dodaj',
        cancel: 'Anuluj',
        ok: 'OK',
        yes: 'Tak',
        no: 'Nie',
        confirm: 'Potwierdź',
        save: 'Zapisz',
        edit: 'Edytuj',
        delete: 'Usuń',
        back: 'Wstecz',
        close: 'Zamknij',
        resetFilters: 'Resetuj filtry',
        search: 'Szukaj',
        send: 'Wyślij'
    },
    tooltips: {
        edit: 'Edytuj',
        selectRowFirst: 'Najpierw wybierz proces.',
        print: 'Wydrukuj etykietę',
        delete: 'Usuń',
        importData: 'Importuj dane'
    },
    units: {
        km: 'km',
        mm: 'mm',
        packages: 'opak.',
        pcs: 'szt.',
        pln: 'zł'
    },
    scale: {
        title: 'Waga',
        noReading: 'Brak odczytu',
        noConnection: 'Brak połączenia z wagą',
        error: 'Błąd odczytu z wagi.',
        belowMin: 'Karton nie osiągnął minimalnej dopuszczalnej wagi, nadanie przesyłki nie jest możliwe.',
        aboveMax: 'Karton przekroczył maksymalną wagę kartonu, konieczne jest jego przepakowanie.'
    },
    table: {
        actions: 'Akcje',
        noData: 'Brak danych'
    },
    adviceNotes: {
        title: 'Awizacja od klienta',
        fields: {
            supplier: 'Dostawca',
            estimatedPaperDeliveryDate: 'Planowana data dostawy',
            paperType: 'Rodzaj papieru',
            paperWeight: 'Waga papieru',
            numberOfPallets: 'Liczba palet',
            files: 'Wybierz pliki'
        },
        buttons: {
            addAttachment: 'Dodaj'
        },
        headers: {
            fileName: 'Nazwa pliku'
        },
        alerts: {
            noAttachments: 'Nie dodano załączników.',
            maxFileSize: 'Dopuszczalny rozmiar pojedynczego pliku: {size} MB'
        },
        tooltips: {
            downloadAttachment: 'Kliknij żeby pobrać'
        },
        dialogs: {
            deleteAttachment: {
                title: 'Usuwanie załącznika',
                content: 'Czy na pewno chcesz usunąć załącznik: {fileName}?'
            }
        },
        notifications: {
            attachmentAdded: 'Dodano załącznik.'
        },
        errors: {
            fetch: 'Pobranie awizacji nie powiodło się.',
            save: 'Zapisanie awizacji nie powiodło się.',
            uploadAttachment: 'Dodanie załącznika nie powiodło się.',
            deleteAttachment: 'Usunięcie załącznika nie powiodło się.',
            numberOfPalletsMin: 'Liczba palet musi być większa lub równa 1.',
            fileTooLarge: 'Przekroczono dopuszczalny rozmiar pliku: {size} MB.',
            maxAttachments: 'Maksymalnie {count} załączniki.'
        }
    },
    dashboard: {
        title: 'Dashboard',
        menuTitle: 'Dashboard',
        buttons: {
            export: 'Eksportuj',
            generateReport: 'Generuj raport',
            backToProducts: 'powrót do produktów',
            goToModule: 'Przejdź do modułu',
            close: 'Zamknij',
            refresh: 'Odśwież'
        },
        tooltips: {
            showDetails: 'Wyświetl szczegóły',
            export: 'Eksportuj'
        },
        dialogs: {
            delayedProductsTitle: 'Produkty opóźnione na dzień',
            delayedOrdersTitle: 'Zamówienia opóźnione na dzień',
            notSentOrdersTitle: 'Zamówienia do wysyłki na dzień'
        },
        tableHeaders: {
            product: 'Produkt',
            toSend: 'Do wysyłki',
            quantity: 'Nakład',
            details: 'Szczegóły',
            order: 'Zamówienie',
            customerNumber: 'Nr klienta',
            jobNumber: 'Nr zlecenia',
            customer: 'Klient'
        },
        labels: {
            accidentsDividedPerDepartmentTitle: 'Awarie wg działów',
            noWidgets: 'Brak widgetów.',
            noData: 'Brak danych',
            noSiteGroups: 'Nie znaleziono grupy stanowisk',
            noPrefixes: 'Nie znaleziono prefiksu',
            productionDepartment: 'Dział',
            productionSiteGroup: 'Grupa stanowisk',
            machineFree: 'Maszyna wolna',
            generatedAt: 'Wygenerowano',
            page: 'Strona',
            of: 'z',
            itemsPerPage: 'Ilość wyświetlanych elementów'
        },
        notifications: {
            reportWillBeSent: 'Plik zostanie wkrótce przesłany na adres {userEmail}.',
            missingShiftReport: 'Nie znaleziono raportu zmianowego.'
        },
        errors: {
            fetchSectionsFailed: 'Pobranie sekcji panelu nie powiodło się.',
            fetchItemsFailed: 'Pobranie widgetów dashboardu nie powiodło się.',
            fetchWidgetFailed: 'Pobranie danych dla widgetu {codeName} nie powiodło się.',
            fetchOrdersNotSentDetailsFailed: 'Pobranie szczegółowych danych o niewysłanych zamówieniach nie powiodło się.',
            fetchDelayedOrdersDetailsFailed: 'Pobranie szczegółowych danych o opóźnionych zamówieniach nie powiodło się.',
            generateReportFailed: 'Wygenerowanie raportu nie powiodło się.'
        }
    },
    errors: {
        unexpectedError: 'Wystąpił nieoczekiwany błąd.',
        networkError: 'Wystąpił błąd. Brak odpowiedzi serwera lub problemy z siecią.'
    },
    account: {
        passwordResetLinkSent: 'Link do zmiany hasła został wysłany na adres e-mail.',
        passwordResetLinkFailed: 'Wysłanie linku na adres e-mail nie powiodło się.',
        passwordChanged: 'Hasło zostało zmienione.',
        passwordChangeFailed: 'Zmiana hasła nie powiodła się.',
        passwordReset: {
            title: 'Zmiana hasła',
            newPasswordLabel: 'Nowe hasło',
            repeatPasswordLabel: 'Powtórz hasło',
            submitButton: 'Zmień hasło',
            passwordHint: 'Ilość znaków 8-20, duża litera, cyfra oraz znak specjalny.',
            tokenMissing: 'Brak tokenu resetu hasła.',
            newPasswordRequired: 'Proszę podać nowe hasło.',
            repeatPasswordRequired: 'Proszę powtórzyć nowe hasło.',
            passwordsMustMatch: 'Hasła nie są identyczne.',
            passwordRequirements: 'Hasło musi zawierać od 8 do 20 znaków, wielką literę, cyfrę oraz znak specjalny.'
        },
        changePassword: {
            currentPasswordRequired: 'Proszę podać aktualne hasło.'
        }
    },
    auth: {
        loginTitle: 'Logowanie',
        passwordResetTitle: 'Reset hasła',
        requiredFields: 'Login i hasło są wymagane.',
        sessionExpired: 'Twoja sesja wygasła.',
        sessionDurationExceeded: 'Sesja przekroczyła maksymalny czas trwania.',
        tokenRefreshFailed: 'Nie udało się odświeżyć sesji.',
        connectionError: 'Błąd połączenia. Sprawdź swoją sieć i spróbuj ponownie.'
    },
    app: {
        updateAvailableUpdating: 'Dostępna jest nowa wersja aplikacji. Aktualizowanie...',
        updateAvailableOnLogin: 'Dostępna jest nowa wersja aplikacji. Aplikacja zaktualizuje się przy następnym logowaniu.',
        updateFailed: 'Nie udało się zaktualizować aplikacji. Proszę odświeżyć stronę ręcznie.',
        offlineReady: 'Aplikacja gotowa do pracy offline'
    },
    router: {
        noPermission: 'Nie posiadasz uprawnień dla tego widoku.'
    },
    validations: {
        invalidMessage: 'Formularz zawiera błędy. Proszę poprawić wszystkie pola.'
    },
    codeReader: {
        title: 'Znajdź kod QR',
        defaultCamera: 'Domyślna kamera',
        errors: {
            incorrectQrCode: 'Nieprawidłowy kod QR.',
            unsupportedQrCode: 'Nieobsługiwany kod QR.',
            unsupportedQrType: 'Nieobsługiwany typ kodu QR.',
            cameraError: 'Błąd kamery: {name}'
        }
    },
    releaseNotes: {
        menuTitle: 'Co nowego?',
        title: 'Nowości w wersji',
        errors: {
            fetchLatestVersion: 'Pobranie informacji o nowej wersji nie powiodło się.'
        }
    }
}

export default {
    messages: messages,
    locale: 'pl'
}
